import { render, staticRenderFns } from "./FormulateGroupAdapter.vue?vue&type=template&id=addcfa46&"
import script from "./FormulateGroupAdapter.vue?vue&type=script&lang=js&"
export * from "./FormulateGroupAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('addcfa46')) {
      api.createRecord('addcfa46', component.options)
    } else {
      api.reload('addcfa46', component.options)
    }
    module.hot.accept("./FormulateGroupAdapter.vue?vue&type=template&id=addcfa46&", function () {
      api.rerender('addcfa46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula/adapters/Formulate/FormulateGroupAdapter.vue"
export default component.exports